import { QASlipSelection } from "../QASlipSelection";
import { observable } from "mobx";
import { QASlipSelectionType, BaseSlipSelectionType } from "../index";

export type QALiveSlipSelectionType = {
    score1?: string,
    score2?: string,
    danger: boolean
} & BaseSlipSelectionType & QASlipSelectionType;

export class QALiveSlipSelection extends QASlipSelection {
    score1?: string;
    score2?: string;
    @observable danger: boolean;

    constructor(source: QALiveSlipSelectionType) {
        /* istanbul ignore next */
        super(source);
        this.danger = source.danger;
        this.score1 = source.score1;
        this.score2 = source.score2;
    }
}